<!-- Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and -->
<!-- matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, -->
<!-- including without limitation, material generated from the software programs which are displayed on the screen such -->
<!-- as icons, screen display looks, etc. -->

<div class="nav-opt-brand-header">
  @if (!router.url.includes('/mfd')) {
    <nav-bar></nav-bar>
    <status-tray></status-tray>
    <app-cookie-consent></app-cookie-consent>
  }
  <div
    [ngClass]="{
      container: !router.url.includes('/mfd') && router.url != '/',
    }">
    <router-outlet></router-outlet>
  </div>
  @if (!router.url.includes('/mfd')) {
    <nav-footer></nav-footer>
  }
</div>
